import styled from "styled-components";

const lebianaCatchPageDisplay = styled.div`
  background: ${(p) => p.bgImg};
  background-size: cover;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
  text-align: center;
  color: #fff;

  a {
    font-size: 14px;
  }

  .forgotpass {
    display: flex;
    justify-content: flex-end;
  }

  .formsLayout .center .form {
    margin: 30px;
  }

  .libya-success-wrap {
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .libya-success-wrap h1 {
    margin: 0;
    font-size: 1.6rem;
    font-weight: 700;
  }

  .libya-success-wrap p {
    margin: 0;
    font-size: 1rem;
    line-height: 1.4;
    opacity: 0.95;
  }

  .libya-download-btn {
    display: inline-block;
    min-width: 200px;
    margin-top: 8px;
    padding: 12px 28px;
    border-radius: 999px;
    background: #28a745;
    color: #fff !important;
    font-size: 1.05rem;
    font-weight: 700;
    text-decoration: none;
    border: none;
  }

  .libya-download-btn:hover {
    opacity: 0.92;
    color: #fff !important;
    text-decoration: none;
  }

  .libya-redirect-hint {
    margin-top: 8px;
    font-size: 0.9rem;
    opacity: 0.75;
  }
`;

export default lebianaCatchPageDisplay;
